import { render, staticRenderFns } from "./WxVoicePlayer.vue?vue&type=template&id=348fa2b9&scoped=true"
import script from "./WxVoicePlayer.vue?vue&type=script&lang=js"
export * from "./WxVoicePlayer.vue?vue&type=script&lang=js"
import style0 from "./WxVoicePlayer.vue?vue&type=style&index=0&id=348fa2b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348fa2b9",
  null
  
)

export default component.exports